import { Component } from '@angular/core';
import { ActionButtonsConfig } from '@app/core/constants/table-actions';
import { environment } from '@env/environment';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-app-actions',
  templateUrl: './app-actions.component.html',
  styleUrls: ['./app-actions.component.scss'],
})
export class AppActionsComponent implements ICellRendererAngularComp {
  params: any;
  actionsList: any = [];

  agInit(params: ICellRendererParams): void {
    this.params = params;
    if (params['page'] == 'app') {
      this.actionsList = ActionButtonsConfig.APP_ACTIONS;
    } else if (params['page'] == 'users') {
      let connection: any;
      if (params?.data?.identities?.length) {
        connection = params?.data.identities[0].connection;
      }
      if (connection == environment.authMasterDb) {
        this.actionsList = ActionButtonsConfig.USERS_PWD_ACTIONS;
      } else {
        this.actionsList = ActionButtonsConfig.USERS_ACTIONS;
      }
    } else if (params['page'] == 'organizations') {
      this.actionsList = ActionButtonsConfig.ORG_ACTIONS;
    }
  }
  /**
   * gets called whenever the cell refreshes
   */
  refresh(_params: ICellRendererParams): boolean {
    return true;
  }

  getExtraButtons(allbuttons) {
    return this.actionsList.length > 3 ? allbuttons.slice(2) : allbuttons.slice(3);
  }
  /**
   * On item click return selected params
   */
  onItemClick(actionKey) {
    const params = {
      action: actionKey.key,
      rowData: this.params.node.data,
    };
    this.params.onActionItemSelect(params);
  }

  /**
   * Track actions loop
   */
  identifyActions(_index, item) {
    return item.actionName;
  }
}
